import React from "react";
import logo from '../assets/logo.webp';

const Footer = () => {
  return (
    <footer className="mt-[30px] bg-brand-brown pt-12 pb-6 max-[480px]:pt-10 max-[480px]:pb-4 text-center text-white standard-padding">
      <div className="flex justify-around items-center w-full mx-auto flex-wrap gap-y-[30px] max-[840px]:flex-col">

        {/* Contact Section */}
        <div className="flex-1 m-2.5">
          <h3 className="text-sm mb-2.5 font-bold">Get in touch</h3>
          <p className="text-sm my-1 tracking-[0.5px]">34, Wellington Road,<br />Eccles<br />M30 0NP</p><br />
          <p className="text-sm my-1">
            <a href="tel:01615660344" className="no-underline text-white hover:underline">0161 566 0344</a>
          </p>
          <div className="flex justify-center gap-[15px] mt-2.5">
            <a href="https://www.instagram.com/lasgidirestaurantandlounge/" className="text-base text-white transition-colors duration-300 no-underline hover:text-brand-orange">
              <i className="fab fa-instagram" />
            </a>
            <a href="https://wa.me/447368325136" className="text-base text-white transition-colors duration-300 no-underline hover:text-brand-orange">
              <i className="fab fa-whatsapp" />
            </a>
            <a href="mailto:restaurantlasgidi@gmail.com" className="text-base text-white transition-colors duration-300 no-underline hover:text-brand-orange">
              <i className="fas fa-envelope" />
            </a>
          </div>
        </div>

        {/* Logo Section */}
        <div className="flex-1 m-2.5 text-center">
          <img src={logo} alt="logo" className="w-[180px] mx-auto" />
          <p className="mt-[15px] text-white text-sm">
            At Lasgidi Restaurant, we are dedicated to serving delicious, high-quality meals made with the freshest ingredients.
          </p>
        </div>

        {/* Working Hours Section */}
        <div className="flex-1 m-2.5">
          <h3 className="text-sm mb-2.5 font-bold">Opening Hours</h3>
          <p className="text-sm my-1"><strong>Monday:</strong> 13:00 - 22:00</p>
          <p className="text-sm my-1"><strong>Tuesday:</strong> 13:00 - 22:00</p>
          <p className="text-sm my-1"><strong>Wednesday:</strong> 13:00 - 22:00</p>
          <p className="text-sm my-1"><strong>Thursday:</strong> 13:00 - 22:00</p>
          <p className="text-sm my-1"><strong>Friday:</strong> 13:00 - 22:00</p>
          <p className="text-sm my-1"><strong>Saturday:</strong> 13:00 - 22:00</p>
          <p className="text-sm my-1"><strong>Sunday:</strong> 13:00 - 22:00</p>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="mt-5 pt-4 pb-0 border-t border-[#ccc] text-white text-sm">
        <p className="m-0"><strong>Lasgidi Restaurant</strong> © 2026 All rights reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
